/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Header from "./components/Header";
import SecretCodeForm from "./components/SecretCodeForm";
import SubmitFeedback from "./components/SubmitFeedback";
import Loading from "@/components/Loading";
import { endTime } from "./config";
import styles from "./page.module.scss";
import { useBitKeepContext } from "@/components/BitKeepProvider";
import { useBitKeepDetection } from "@/hooks/useBitKeepDetection";
import { showToast } from "@/shares/feedback/showToast";
import { isDateAfter } from "@/shares/utils/date";
import { getUserBgwAddressForm, fillUserBgwAddressForm, getAirdropResult } from "@/apis/tomarket";
const BitgetWalletActivity = ()=>{
    const containerRef = useRef();
    const [loading, setLoading] = useState(true);
    const translationPageKey = "Tomarket_activity";
    const t = useTranslations("");
    // console.log('==>',t)
    // debugger;
    // TODO: for testing, remove before mr
    // const  chainObj  = {
    //   apt:'0xaa0270a2d69bf311810b90d3c6329976f3a03a866cf834b782109e42274b5d83'
    // }
    const [aptAddress, setAptAddress] = useState("");
    const [submissionStatus, setSubmissionStatus] = useState(false);
    const [airdropResult, setAirdropResult] = useState(null);
    const { bitkeep, isReady } = useBitKeepContext();
    const isBitkeep = useBitKeepDetection();
    // const [alreadyInit, setAlreadyInit] = useState<boolean>(false);
    useEffect(()=>{
        if (isReady && bitkeep && isBitkeep) {
            const init = async ()=>{
                try {
                    // const { success: haveApt } = await bitkeep.checkHaveChain('apt');
                    // console.log('checkHaveChain-haveApt', haveApt);
                    // if (!haveApt) {
                    //   showToast('warning', 'in creatChain');
                    //   await bitkeep.creatChain('apt');
                    // }
                    // setAlreadyInit(true);
                    bitkeep.setTitle("");
                    console.log("getTokenListInfo-begin");
                    const { success: haveAptToken, data } = await bitkeep.getTokenListInfo("apt");
                    if (haveAptToken) {
                        var _data_tokenList, _data_tokenList1;
                        console.log("haveAptToken", data === null || data === void 0 ? void 0 : (_data_tokenList = data.tokenList) === null || _data_tokenList === void 0 ? void 0 : _data_tokenList.address);
                        if ((data === null || data === void 0 ? void 0 : (_data_tokenList1 = data.tokenList) === null || _data_tokenList1 === void 0 ? void 0 : _data_tokenList1.address) !== undefined) {
                            var _data_tokenList2, _data_tokenList3, _data_tokenList4;
                            console.log("haveAptToken-true", data === null || data === void 0 ? void 0 : (_data_tokenList2 = data.tokenList) === null || _data_tokenList2 === void 0 ? void 0 : _data_tokenList2.address);
                            window.localStorage.setItem("toma-apt-address", data === null || data === void 0 ? void 0 : (_data_tokenList3 = data.tokenList) === null || _data_tokenList3 === void 0 ? void 0 : _data_tokenList3.address);
                            setAptAddress(data === null || data === void 0 ? void 0 : (_data_tokenList4 = data.tokenList) === null || _data_tokenList4 === void 0 ? void 0 : _data_tokenList4.address);
                            setTimeout(()=>{
                                var _data_tokenList;
                                checkSubmission(data === null || data === void 0 ? void 0 : (_data_tokenList = data.tokenList) === null || _data_tokenList === void 0 ? void 0 : _data_tokenList.address);
                            });
                        }
                    } else {
                        showToast("fail", "".concat(t("".concat(translationPageKey, "_retrieve_address_failed"))));
                    }
                } catch (err) {
                    console.error("Init Error:", err);
                }
                setLoading(false);
            };
            init();
        } else {
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isReady,
        bitkeep,
        isBitkeep
    ]);
    console.log("aptAddress:", aptAddress);
    // useEffect(() => {
    //   console.log('aptAddress-changed', aptAddress);
    //   if (aptAddress) {
    //     checkSubmission(aptAddress);
    //   }
    // }, [aptAddress]);
    const checkSubmission = async (address)=>{
        var _window___bitkeepAccount, _window, _window___bitkeepAccount1, _window1;
        const triedAddress = address || ((_window = window) === null || _window === void 0 ? void 0 : (_window___bitkeepAccount = _window.__bitkeepAccount) === null || _window___bitkeepAccount === void 0 ? void 0 : _window___bitkeepAccount.apt) || window.localStorage.getItem("toma-apt-address");
        console.log("checkSubmission-fire", address, (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window___bitkeepAccount1 = _window1.__bitkeepAccount) === null || _window___bitkeepAccount1 === void 0 ? void 0 : _window___bitkeepAccount1.apt, window.localStorage.getItem("toma-apt-address"));
        const result = await getUserBgwAddressForm.fetcher({
            address: triedAddress
        });
        if (result) {
            setSubmissionStatus(true);
        }
    };
    const handleSubmission = async (code)=>{
        try {
            var _window___bitkeepAccount, _window;
            const address = aptAddress || window.localStorage.getItem("toma-apt-address");
            console.log("handleSubmission-address-localAddress", (_window = window) === null || _window === void 0 ? void 0 : (_window___bitkeepAccount = _window.__bitkeepAccount) === null || _window___bitkeepAccount === void 0 ? void 0 : _window___bitkeepAccount.apt, "====", aptAddress, window.localStorage.getItem("toma-apt-address"));
            if (!address) {
                showToast("fail", "".concat(t("".concat(translationPageKey, "_retrieve_address_failed"))));
                return true;
            }
            const result = await fillUserBgwAddressForm.fetcher({
                address,
                code
            });
            if (result) {
                console.log("submit success", result);
                showToast("success", "".concat(t("".concat(translationPageKey, "_code_accepted"))));
                setSubmissionStatus(true);
            }
            return true;
        } catch (error) {
            return false;
        }
    };
    useEffect(()=>{
        const address = aptAddress || window.localStorage.getItem("toma-apt-address");
        if (!address) return;
        getUserAirdropResult();
    }, [
        aptAddress
    ]);
    const getUserAirdropResult = async ()=>{
        try {
            const address = aptAddress || window.localStorage.getItem("toma-apt-address");
            if (!address) {
                showToast("fail", "".concat(t("".concat(translationPageKey, "_retrieve_address_failed"))));
                return true;
            }
            const result = await getAirdropResult.fetcher({
                address
            });
            console.log("result:", result);
            setAirdropResult(result);
            return result;
        } catch (error) {
            return null;
        }
    };
    const onFormFocus = ()=>{
        setTimeout(()=>{
            var _containerRef_current;
            containerRef === null || containerRef === void 0 ? void 0 : (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollTo({
                top: 660,
                behavior: "smooth"
            });
        }, 400);
    };
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        className: "w-full h-full bg-[#fff] overflow-y-auto",
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: loading ? "block" : "none"
                },
                children: /*#__PURE__*/ _jsx(Loading, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center w-full h-full min-h-[600px] px-[20px] ".concat(styles.page),
                children: [
                    /*#__PURE__*/ _jsx(Header, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1 w-full ".concat(styles.contentContainer),
                        children: isDateAfter(endTime) || submissionStatus === true ? /*#__PURE__*/ _jsx(SubmitFeedback, {
                            airdropRes: airdropResult
                        }) : /*#__PURE__*/ _jsx(SecretCodeForm, {
                            onFormFocus: onFormFocus,
                            onSubmit: handleSubmission
                        })
                    })
                ]
            })
        ]
    });
};
export default BitgetWalletActivity;
